import Database from '@/services/offline/database.js'

class QualificationsCache extends Database {

  constructor() {
    super()
  }

  _storeName() {
    return 'qualifications'
  }

  /**
   * @param {Object} param - Cache parameters
   * @param {Object[]} param.qualifications - Qualifications to cache
   */
  async cache({ qualifications }) {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    await db.put(this._storeName(), qualifications, storageKey)
  }

  async get() {
    let storageKey = this._createStorageKey()

    const db = await this.dbPromise
    return await db.get(this._storeName(), storageKey)
  }

  async cachePresent() {
    return !!(await this.get())
  }

  async deleteAllCache() {
    const db = await this.dbPromise
    return await db.clear(this._storeName())
  }

  _createStorageKey() {
    return 'qualifications'
  }
}

export default new QualificationsCache()